export const LOADER_DURATION = 0;